import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import olympiadApi from '@/api/olympiads'

export default {
  state: {
    currentOlympiad: {}
  },

  mutations: {
    [MUTATION_TYPE.setCurrentOlympiad]: (state, olymp) => {
      state.currentOlympiad = olymp
    }
  },

  actions: {
    [ACTION_TYPE.fetchCurrentOlympiad]: ({ commit }) => new Promise((resolve, reject) => {
      olympiadApi.getCurrentOlympiad()
        .then((response) => {
          commit('setCurrentOlympiad', response.data)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.registerInOlympiad]: () => new Promise((resolve) => {
      olympiadApi.registrationInOlymiad()
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          resolve(error.response)
        })
    })
  },
  getters: {
    [GETTER_TYPE.getCurrentOlympiad]: (state) => state.currentOlympiad
  }
}
